import React, { Component } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";

import {
  WORD_ICON,
  TEXT_ICON,
  PDF_ICON,
  EXCEL_ICON,
} from "../../assets/js/image";
import Dropzone from "./Dropzone/Dropzone";
import { httpPostNotificationFileUpload } from "../../service/httpClient";
import Cookie from "js-cookie";
import "./PublishNotification.css";

let formData = new FormData();

class PublishNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      newFile: [],
      showModal: true,
      disabled: true,
      publishSuccess: null,
      selectValue: "",
      selectedValue: [],
      finalUpload: [],
      userMessage: false,
      errMessage: "",
      remainingChars: 0,
      limit: 0,
      notificationText: "",
    };

    this.onFilesAdded = this.onFilesAdded.bind(this);
    this.uploadFilesBtn = this.uploadFilesBtn.bind(this);
    this.replaceFiles = this.replaceFiles.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleCancel = () => (window.location = "/mvp");

  handleChange(e) {
    if (e.target.name === "selectValue") {
      let remainingChars = e.target.value === "resource" ? 50 : 500;
      this.setState({
        notificationText: "",
        errMessage: "",
        remainingChars: remainingChars,
        publishSuccess: null,
        limit: remainingChars,
        files: [],
        selectedValue: [],
        newFile: "",
        disabled: e.target.value ? false : true,
        [e.target.name]: e.target.value,
      });
    }
    if (this.state.selectValue && e.target.name === "notificationText") {
      if (e.target.value.length <= this.state.limit) {
        this.setState({
          remainingChars: this.state.limit - e.target.value.length,
          [e.target.name]: e.target.value,
        });
      }
    }
  }

  onFilesAdded(files) {
    if (this.state.selectValue == "") {
      this.setState({ errMessage: "Please select the value from drop down" });
      return;
    }

    if (files.type == "") {
      this.setState({ errMessage: "Unsupported file format" });
      return;
    }

    if (this.state.selectValue !== "" && files.type !== "") {
      this.setState({ newFile: files, errMessage: "" });

      if (this.state.files.length === 0) {
        this.setState((prevState) => ({
          files: prevState.files.concat(files),
          selectedValue: prevState.selectedValue.concat(this.state.selectValue),
          disabled: true,
        }));
      }
    }
  }

  uploadFilesBtn() {
    if (this.state.files) {
      const mapValues = {
        notificationFile: this.state.files[0] || "",
        notificationType: this.state.selectValue,
        notificationMessage: this.state.notificationText,
        userName: Cookie.get("userName"),
        email: Cookie.get("email"),
      };

      for (let [key, value] of Object.entries(mapValues)) {
        if (!formData.has(key)) {
          formData.append(key, value);
        } else {
          formData.set(key, value);
        }
      }

      httpPostNotificationFileUpload(formData)
      .then((res) => {
          if (res.status === 200) {
            window.location = "/mvp";
          } else {
            this.setState({
              files: [],
              selectedValue: [],
              disabled: false,
              publishSuccess: true,
            });
            this.props.onHide();
            Array.from(formData.keys()).forEach((key) => formData.delete(key));
          }
        })
        .catch((error) => {
          this.setState({
            files: [],
            selectedValue: [],
            disabled: false,
            publishSuccess: false,
          });
          this.props.onHide();
          Array.from(formData.keys()).forEach((key) => formData.delete(key));
        });
    }
  }

  fileFormateIcon(file) {
    const fileDetails = file.name.split(".");
    if (fileDetails[1] === "txt") {
      return <TEXT_ICON style="publishNotification_Format_icon" altText="txt" id="text_icon" />;
    } else if (fileDetails[1] === "docx" || fileDetails[1] === "doc") {
      return <WORD_ICON style="publishNotification_Format_icon" altText="txt" id="word_icon" />;
    } else if (fileDetails[1] === "pdf") {
      return <PDF_ICON style="publishNotification_Format_icon" altText="txt" id="text_icon" />;
    } else if (
      fileDetails[1] === "xlsx" ||
      fileDetails[1] === "xls" ||
      fileDetails[1] === "ods" ||
      fileDetails[1] === "csv"
    ) {
      return <EXCEL_ICON style="publishNotification_Format_icon" altText="txt" id="excel_icon" />;
    }
  }

  deleteFile(e, index) {
    e.preventDefault();
    let temp1 = [...this.state.files];
    let temp2 = [...this.state.selectedValue];
    if (index !== -1) {
      const deltFile = temp1.splice(index, 1);
      temp2.splice(index, 1);
      deltFile[0].name === this.state.newFile.name
        ? this.setState({
          files: temp1,
          selectedValue: temp2,
          userMessage: false,
          disabled: false,
          newFile: "",
        })
        : this.setState({ files: temp1, selectedValue: temp2, newFile: "" });
    }
  }

  replaceFiles() {
    const deft = [...this.state.files];
    const val = [...this.state.selectedValue];
    for (var i = 0; i < deft.length; i++) {
      if (deft[i].name === this.state.newFile.name) {
        formData.delete(val[i], deft[i]);
        deft.splice(i, 1);
        val.splice(i, 1);
      }
    }
    val.push(this.state.selectValue);
    deft.push(this.state.newFile);
    this.setState({
      userMessage: false,
      files: deft,
      selectedValue: val,
      disabled: false,
    });
  }

  sizeCalc = (size) => {
    if (size >= 1073741824) {
      size = (size / 1073741824).toFixed(2) + " GB";
    } else if (size >= 1048576) {
      size = (size / 1048576).toFixed(2) + " MB";
    } else if (size >= 1024) {
      size = (size / 1024).toFixed(2) + " KB";
    } else if (size > 1) {
      size = size + " bytes";
    } else if (size === 1) {
      size = size + " byte";
    } else {
      size = "0 byte";
    }

    return size;
  };

  disableSubmit = () => {
    if (
      this.state.selectValue === "resource" &&
      this.state.notificationText &&
      this.state.files.length > 0
    ) {
      return false;
    } else if (
      this.state.selectValue === "notification" &&
      this.state.notificationText
    ) {
      return false;
    } else return true;
  };

  render() {
    return (
      <Modal
        show={this.state.showModal}
        contentClassName="publishNotificationModal"
      >
        <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
            Publish Notification
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="publishNotificationModalBody">
          {this.state.publishSuccess === false && (
            <Row>
              <div
                className="submitErrorMessage"
                style={{ color: "#d64a4a", marginLeft: 30 }}
              >
                Unable to publish {this.state.selectValue}!
              </div>
            </Row>
          )}
          <Row className="show-grid">
            <Col xs={12} md={12} lg={4} className="publishContainerColumn">
              <select
                className="drop_downBox"
                name="selectValue"
                id="selectValue"
                value={this.state.selectValue}
                onChange={(e) => this.handleChange(e)}
              >
                <option value="">Select Notification Type</option>
                <option value="notification">Notification</option>
                <option value="resource">Resource</option>
              </select>
            </Col>
            <Col xs={12} md={12} lg={6} className="publishContainerColumn">
              <textarea
                name="notificationText"
                id="notificationText"
                className="publishNotificationText"
                onChange={this.handleChange}
                disabled={!this.state.selectValue}
                value={this.state.notificationText}
                cols="33"
                rows="5"
                placeholder={
                  this.state.selectValue === "resource"
                    ? "Enter resource title here..."
                    : "Enter notification here..."
                }
              ></textarea>
              <p>Characters remaining = {this.state.remainingChars}</p>

              <div className="publishNotificationDropDown">
                <Dropzone
                  onFilesAdded={this.onFilesAdded}
                  pendingFiles={this.state.files}
                  disabled={this.state.disabled}
                />
              </div>
            </Col>
          </Row>

          {this.state.files.length > 0 && (
            <Row>
              <Col>
                <div className="publishNotificationFiles">
                  {this.state.files.map((file, index) => {
                    return (
                      <div key={file.name}>
                        {this.fileFormateIcon(file)}
                        <span className="publishNotificationFilename">
                          {this.state.selectedValue[index]}_{file.name}(
                          {this.sizeCalc(file.size)}
                          ).
                          <span
                            className="publishNotification_Delete_files"
                            onClick={(e) => this.deleteFile(e, index)}
                          >
                            X
                          </span>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer className="publishNotificationFooter">
          <Row className="publishNotification_footer_row">
            <Col xs={12} md={6} className="publishNotificationFooterColumn">
              <Button className="button-later-md publishNotification_footer_cancelBtn"
                onClick={() => this.handleCancel()}
              >
                CANCEL
              </Button>
            </Col>
            <Col xs={12} md={6} className="publishNotificationFooterColumn">
              {!this.state.userMessage && (
                <Button
                  className="button-primary-md publishNotification_footer_uploadBtn"
                  onClick={this.uploadFilesBtn}
                  disabled={this.disableSubmit()}
                >
                  PUBLISH
                </Button>
              )}
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PublishNotification;
